/* eslint-disable camelcase */
import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext"

const ranges = ["very_low", "low", "medium", "high", "very_high"]

const EmpathcyCompassionAssessment = () => {
	const { respondent } = useUser();
	const { reportContent: { acf: { empathy_compassion } } } = useReport();

	const percentile = parseInt( respondent?.weqProfile?.percentiles?.eMC_sub_WTFS / 20, 10);

	return <div className={`assessment-text rating-${ranges[percentile]}`} dangerouslySetInnerHTML={{ __html: empathy_compassion[ ranges[percentile] ] }} />
}

export default EmpathcyCompassionAssessment;